import React from "react";
import Hotkeys from "react-hot-keys";

const HotkeysHandler = ({ keys, handler }) => {
  return (
    <Hotkeys
      filter={(event) => {
        return true;
      }}
      keyName={keys}
      onKeyDown={handler}
    />
  );
};
export default HotkeysHandler;
